import { useDynamicTokens } from '@trello/dynamic-tokens';

import { useCurrentBoardBackground } from './useBoardBackground';

/**
 * Assigns dynamic tokens for the current board background to a given element.
 */
export function useDynamicBoardTokens(
  props: Omit<Parameters<typeof useDynamicTokens>[0], 'background'>,
) {
  const {
    backgroundBrightness,
    backgroundColor,
    backgroundTopColor,
    isBackgroundImage,
  } = useCurrentBoardBackground();

  useDynamicTokens({
    ...props,
    background: {
      backgroundBrightness,
      backgroundColor: isBackgroundImage ? backgroundTopColor : backgroundColor,
      isBackgroundImage,
    },
  });
}
